export default function (state, data) {
    state.loading = false;
    state.items = [];
    setRow(data, state.items)
}
function setRow(data, list) {
    data.forEach(i=>{
        list.push({
            Acc: i.Acc,
            Name: i.Name,
            InitialDebitBalance: i.InitialDebitBalance,
            InitialCreditBalance: i.InitialCreditBalance,
            DebitTurnover: i.DebitTurnover,
            CreditTurnover: i.CreditTurnover,
            FinalDebitBalance: i.FinalDebitBalance,
            FinalCreditBalance: i.FinalCreditBalance,
            CurrencyName: i.CurrencyName,
            // FinalCreditBalance: i.FinalCreditBalance,
        });

    })
}